// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"527e4f37","201":"dd1a07be","295":"e834bfbf","363":"a4400b48","445":"624f286e","453":"44ba8801","464":"3a509d17","473":"0cc41e0d","729":"3503a5f2","883":"256474d6","885":"e928a1b3","946":"cdcf39a5"}[chunkId] + ".chunk.js";
};